const getIsRoomCardMessage = (message) => {
  const data = parseMessageData(message);
  return (data == null ? void 0 : data.businessID) === "group_room_message";
};
const parseMessageData = (message) => {
  var _a;
  try {
    const data = (_a = message == null ? void 0 : message.payload) == null ? void 0 : _a.data;
    return data ? JSON.parse(data) : {};
  } catch (err) {
    console.warn("parseMessageData error:", err);
    return {};
  }
};
export {
  getIsRoomCardMessage,
  parseMessageData
};
